import React, { useEffect, useState, useContext } from "react";
import SelectOption from "./SelectOption";
import top100Films from "./top100films";
import axios from "axios";
import AppContext from "../../../context/app-context";
import SiteCode from "../Reports/SiteCode";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SingleLineChart from "./SingleLineChart";
import { Chart } from "react-google-charts";
import Cardline from "./Cardline";
import { LogarithmicScale } from "chart.js";
import MultipleSelectCheckmarks from "../Reports/MultipleSelectCheckmarks";
import Road from "../Reports/Road";
import Towards from "../Reports/Towards";
import Example from "../Device/CallReportChart";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useAuth } from "../../../context/AuthContext";
import { getAuth } from "firebase/auth";
import { Chip } from "@mui/material";

const url = process.env.REACT_APP_URL;

function CardSection() {
  const auth = getAuth();
  const {
    message,
    callTime,
    setcallTime,
    road,
    towards,
    busStop,
    ts,
    setTs,
    setEmergency,
    emergency,
    numberOfFunctional,
    numberOfNonFunctional,
  } = useContext(AppContext);

  const [callMode, setCallMode] = useState("");
  const [noOfInstalledDevices, setNoOfInstalledDevices] = useState("");
  const [data, setData] = useState([]);
  const [district, setDistrict] = React.useState("");
  const [location, setLocation] = React.useState("");
  const [value, setValue] = React.useState("Lodhi Colony");
  const [duration, setDuration] = React.useState(20);
  const [dataOfNumberOfCalls, setDataOfNumberOfCalls] = useState([]);
  const { currentUserLogged } = useAuth();
  const handleChange = (event) => {
    setDuration(event.target.value);
  };
  const siteCodes = [{ value: "chocolate", label: "C-22-P" }];
  const busStops = [{ value: "chocolate", label: "Palika Kendra" }];
  const roads = [{ value: "chocolate", label: "Sansad Marg" }];
  const towardss = [{ value: "chocolate", label: "Parliament House" }];
  const handleChangedistrict = (event) => {
    setDistrict(event.target.value);
  };

  const handleChangeLocation = (event) => {
    setLocation(event.target.value);
  };

  useEffect(() => {
    const user = auth.currentUser;
    // console.log(user.email);
    if (duration === 10) {
      const d = new Date();
      const today = d.toISOString().split("T")[0];
      const d2 = new Date();
      const sevenDaysBefore = d2.setDate(d.getDate() + 1);
      const g = new Date(sevenDaysBefore);
      var tomorrow = g.toISOString().split("T")[0];

      axios
        .get(
          `${url}/api/v1/number_of_calls?startOffset=${today}&endOffset=${tomorrow}`
        )
        .then((response) => {
          setDataOfNumberOfCalls(response.data.data);
        });
    } else if (duration === 20) {
      const d = new Date();
      const h = d.toISOString().split("T")[0];
      const sevenDaysBefore = d.setDate(d.getDate() - 7);
      const g = new Date(sevenDaysBefore);
      var t = g.toISOString().split("T")[0];

      axios
        .get(`${url}/api/v1/number_of_calls?startOffset=${t}&endOffset=${h}`)
        .then((response) => {
          setDataOfNumberOfCalls(response.data.data);
        });
    } else if (duration === 30) {
      const d = new Date();
      var t = d.toISOString().split("T")[0];
      axios
        .get(
          `${url}/api/v1/number_of_calls?startOffset=2022-08-01&endOffset=${t}`
        )
        .then((response) => {
          setDataOfNumberOfCalls(response.data.data);
        });
    }

    // let one = `${url}/api/v1/get_data`;

    // const requestOne = axios.get(one);

    // axios
    //   .all([requestOne])
    //   .then(
    //     axios.spread((...responses) => {
    //       const responseOne = responses[0];

    //       setcallTime(responseOne.data.data.call_time);
    //       setCallMode(responseOne.data.data.call_mode);
    //       setData(responseOne.data.data);
    //       setTs(responseOne.data.data.ts);

    //       var date1 = new Date(responseOne.data.data.ts.slice(0, 19) + " UTC");
    //       var ws = date1.toString();
    //       var ds = ws.slice(0, 24);
    //       console.log(ds);
    //       console.log(ws);
    //       console.log(date1);
    //       var now = new Date();
    //       console.log(now);
    //       console.log(Math.floor((now - date1) / 60000));
    //       if (Math.floor((now - date1) / 60000) <= 3) {
    //         setEmergency(true);
    //       }
    //     })
    //   )
    //   .catch((errors) => {
    //     // react on errors.
    //   });
    axios.get(`${url}/core_data/device/installation`).then((response) => {
      // console.log( "installation data", response.data);
      const parsedNoOfInstallation = parseInt(response.data.sites);
      setNoOfInstalledDevices(parsedNoOfInstallation);
    });
  }, [duration]);
  var date1 = new Date(ts.slice(0, 19) + " UTC");

  var ws = date1.toString();
  const totalDevices = Number(noOfInstalledDevices || 0);
  const operationalDevices = Number(numberOfFunctional || 0);
  const nonOperationalDevices = Number(numberOfNonFunctional || 0);
  const emergencyActive = Boolean(emergency);

  return (
    <div>
      <div
        className="shadow-sm rounded-4 p-3 mb-3"
        style={{
          background: emergencyActive
            ? "linear-gradient(135deg, #ffe9e9 0%, #ffffff 100%)"
            : "linear-gradient(135deg, #eef4ff 0%, #ffffff 100%)",
          borderLeft: `8px solid ${emergencyActive ? "#e53935" : "#1b5e20"}`,
        }}
      >
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div>
            <h5 className="mb-1 fw-bold">
              {emergencyActive ? "Emergency Active" : "System Healthy"}
            </h5>
            <div className="text-muted">
              {emergencyActive
                ? "The latest button press has marked the device red in real time."
                : "Live status is syncing from the backend and the device stays green until a button press arrives."}
            </div>
          </div>
          <Chip
            label={emergencyActive ? "LIVE ALERT" : "LIVE STATUS"}
            color={emergencyActive ? "error" : "success"}
            variant="filled"
          />
        </div>
      </div>

      <div className="contain mt-4">
        <div className="row g-3">
          <div className="col-12 col-md-4">
            <div
              className="card shadow-sm p-3 h-100 bg-white rounded-4 text-center border-0"
              style={{ minHeight: 150, borderTop: "5px solid #1e88e5" }}
            >
              <div className="card-header bg-transparent border-0 fw-semibold text-secondary">
                Total
              </div>
              <ul className="list-group list-group-flush">
                <li className="list-group-item border-0 fs-3 fw-bold">
                  {totalDevices}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div
              className="card shadow-sm p-3 h-100 bg-white rounded-4 text-center border-0"
              style={{ minHeight: 150, borderTop: "5px solid #43a047" }}
            >
              <div className="card-header bg-transparent border-0 fw-semibold text-success">
                Installed
              </div>
              <ul className="list-group list-group-flush">
                <li className="list-group-item border-0 fs-3 fw-bold">
                  {operationalDevices}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div
              className="shadow-sm p-3 h-100 bg-white rounded-4 text-center card border-0"
              style={{ minHeight: 150, borderTop: "5px solid #e53935" }}
            >
              <div className="card-header bg-transparent border-0 fw-semibold text-danger">
                In Progress
              </div>
              <ul className="list-group list-group-flush">
                <li className="list-group-item border-0 fs-3 fw-bold">
                  {nonOperationalDevices}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row mt-2 mb-1">
          <Box sx={{ maxWidth: 180, textAlign: "center" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={duration}
                label="Age"
                onChange={handleChange}
              >
                <MenuItem value={10}>Today</MenuItem>
                <MenuItem value={20}>Last 7 days</MenuItem>
                <MenuItem value={30}>All</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </div>
        <div
          className="row  text-center"
          style={{ width: "auto", overflow: "scroll" }}
        >
          <div className="col shadow-md text-center mb-2 ms-2">
            <Example data={dataOfNumberOfCalls} height={250} width={500} />
          </div>
        </div>
        {/* <div className="row mb-4 text-center">
        
          <div className="col-lg-4 text-center">
          <MultipleSelectCheckmarks />
          </div>
          <div className="col-lg-4 text-center">
          <Road/>
          </div>
          <div className="col-lg-4 text-center">
          <Towards />
          </div>
        </div> */}

        {/* <div className="con">
          <div className="row">
            <div className="shadow p-3 mb-5 bg-white rounded text-center col-lg-6 ">
              <ul class="list-group">
                <li
                  style={{ paddingBottom: "0px" }}
                  class="list-group-item text-success"
                >
                  <b>{ds}</b>
                </li>
                <li class="list-group-item text-success">
                  <b>Device last Active time</b>
                </li>
              </ul>
            </div>
            <div className="shadow-md p-1 mb-5 bg-white rounded text-center col-lg-6">
              <ul class="list-group">
                <li class="list-group-item text-primary">
                  <b>Call Duration(sec) :- {callTime}</b>
                </li>
                <li class="list-group-item text-primary">
                  <b>Recent Call Mode :- {callMode}</b>
                </li>
              </ul>
            </div>
          </div>
         
        </div> */}

        {/* <div className="color">
          <div class="square shadow-sm p-3 mb-5  rounded"></div>
          <p className="hi">Device Active and button pressed</p>
          <div class="square shadow-sm p-3 mb-5  rounded"></div>
          <div class="square shadow-sm p-3 mb-5  rounded"></div>
        </div> */}
        {/* <div className="color shadow-sm">
          <div style={{ marginTop: "-20px" }} className="text">
            <h6>Device Color indication</h6>
          </div>
          
          <div style={{ marginLeft: "22px" }} className="wrap1">
            <div class="green ani shadow-none p-3 mb-1 tooltip1">
              <span class="wid-1 tooltiptext1">
                Device Active & Button Pressed
              </span>
            </div>
            <div class="ani shadow-none p-3 mb-1 yellow tooltip1">
              <span class="wid-2 tooltiptext1">Device Active</span>
            </div>
            <div class="ani shadow-none p-3 mb-1 red tooltip1">
              <span class="wid-3 tooltiptext1">Device inactive</span>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
export default CardSection;
